import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Layout from './layouts/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Finances from './pages/Finances';
import Ledger from './pages/Ledger';
import Loans from './pages/Loans';
import Subscription from './pages/Subscription';
import ForgotPassword from './pages/ForgotPassword';
import './styles/App.css';

function App() {
  const navigate = useNavigate();
  const [showDashboard, setShowDashboard] = useState(!!localStorage.getItem('access_token'));

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      setShowDashboard(true);
    }
  }, []);

  const onLogout = () => {
    localStorage.clear();
    setShowDashboard(false);
    navigate('/login');
  };

  const onLoginSuccess = () => {
    setShowDashboard(true);
  };

  if (showDashboard) {
    return (
      <Layout onLogout={onLogout}>
        <Routes>
          <Route path="/" element={<Dashboard onPageChange={(path) => navigate(`/${path}`)} />} />
          <Route path="/dashboard" element={<Dashboard onPageChange={(path) => navigate(`/${path}`)} />} />
          <Route path="/users" element={<Users onViewUserFinance={(user) => navigate(`/finances/${user.id}`, { state: { user } })} />} />
          <Route path="/finances/:userId" element={<Finances onBack={() => navigate('/users')} />} />
          <Route path="/ledger" element={<Ledger />} />
          <Route path="/loans" element={<Loans />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<Login onLoginSuccess={onLoginSuccess} />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
